module.exports = __webpack_public_path__ + "img/LV1.6b9ffc8e.webp";